var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8142_153443)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.710938,
    y: 0.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#FFFBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7109 9H4.71094C4.4376 9 4.21094 8.77333 4.21094 8.5C4.21094 8.22667 4.4376 8 4.71094 8H12.7109C12.9843 8 13.2109 8.22667 13.2109 8.5C13.2109 8.77333 12.9843 9 12.7109 9Z",
    fill: "#475467"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.21094,
    y: 1,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#475467"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8142_153443"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.710938,
    y: 0.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/removeIcon.8bbee91f23c6cb764ce7068d536ff40a.svg";
export { ForwardRef as ReactComponent };